import axios from "axios";
import Cookies from "js-cookie";

class Auth {
  getHost = () => {
    let REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

    if (
      typeof REACT_APP_BASE_URL === "undefined" ||
      REACT_APP_BASE_URL === "" ||
      REACT_APP_BASE_URL === null
    ) {
      REACT_APP_BASE_URL = "https://dev-sudo.stpay.net/";
    }

    return REACT_APP_BASE_URL;
  };

  login = async (user) => {
    const loginResponse = await axios.post(
      `${this.getHost()}api/v1/auth/login/otp-generate`,
      {
        email: user.email,
        password: user.password,
      }
    );
    return loginResponse.data;
  };
  loginWithOtp = async (user) => {
    const res = await axios.post(
      `${this.getHost()}api/v1/auth/login/otp-verify`,
      {
        email: user.email,
        password: user.password,
        otp: user.userOtp,
      }
    );
    if (res.data.code === 200) {
      if (res.data.data) {
        Cookies.set(
          "fast_pay_acc",
          res.data.data.token,
          { path: "/" },
          { expires: 3 }
        ); //Expire After 3 days
        //  console.log("3 day " + this.state.remember)
        Cookies.set(
          "user",
          res && res.data && res.data.data && res.data.data.user
        );
      }
      return res.data;
    } else {
      return res.data;
    }
  };

  getForgetPasswordOTP = async (logInfo) => {
    const res = await axios.post(
      `${this.getHost()}api/v1/auth/forgot-password/otp-generate`,
      logInfo
    );
    return res.data;
  };

  forgetPassword = async (logInfo) => {
    const res = await axios.post(
      `${this.getHost()}api/v1/auth/forgot-password/otp-verify`,
      logInfo
    );
    return res.data;
  };

  logout = () => {
    Cookies.remove("fast_pay_acc");
    Cookies.remove("user");
    localStorage.clear();
  };
}

export default new Auth();
